import React, { useState } from 'react';
import { CustomScores } from '../CustomScores';
import { CustomSummaries } from './CustomSummaries';
import { CustomEmails } from './CustomEmails';
import { CustomResearch } from './CustomResearch';
import { Typography } from '../../interfaces/typography';

enum AIGenerationTab {
  AI_SCORES = 'AI Scores',
  CUSTOM_SUMMARIES = 'Custom Summaries',
  CUSTOM_EMAILS = 'Custom Emails',
  CUSTOM_RESEARCH = 'Custom Research',
}

export function AIGeneration() {
  const [activeTab, setActiveTab] = useState<AIGenerationTab>(AIGenerationTab.AI_SCORES);

  const renderTab = (tab: AIGenerationTab) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`px-4 py-2 border-b-2 transition-colors duration-200 ${
        activeTab === tab
          ? 'border-blue-600'
          : 'border-transparent hover:border-gray-300'
      }`}
    >
      <Typography
        variant="mediumParagraph"
        color={activeTab === tab ? '#2563eb' : '#6b7280'}
        fontWeight={500}
      >
        {tab}
      </Typography>
    </button>
  );

  const renderContent = () => {
    switch (activeTab) {
      case AIGenerationTab.AI_SCORES:
        return <CustomScores />;
      case AIGenerationTab.CUSTOM_SUMMARIES:
        return <CustomSummaries />;
      case AIGenerationTab.CUSTOM_EMAILS:
        return <CustomEmails />;
      case AIGenerationTab.CUSTOM_RESEARCH:
        return <CustomResearch />;
      default:
        return null;
    }
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header with title and tabs */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="mb-4">
          <Typography variant="h2" color="#1F2937" fontWeight={600}>
            AI Customizations
          </Typography>
          <Typography variant="smallParagraph" color="#6B7280" style={{ marginTop: '0.25rem' }}>
            Customize AI-powered features including scores, summaries, emails, and company research
          </Typography>
        </div>

        {/* Tab Navigation */}
        <div className="flex space-x-6 border-b border-gray-200">
          {Object.values(AIGenerationTab).map((tab) => renderTab(tab))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-auto">
        {renderContent()}
      </div>
    </div>
  );
}
